import { VStack } from "@chakra-ui/react";
import React from "react";

export const FileList: React.FC<React.PropsWithChildren> = ({ children }) => (
  <VStack alignItems="stretch" spacing="8px">
    {children}
  </VStack>
);
